import type { ConfigurationModuleResourceWriteV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { CreateConfigurationModuleParams } from '../../models/configurationModules.model';

export function mapConfigurationModuleCreationParams(
  { name, applicationVersion, softwareType, description }: CreateConfigurationModuleParams,
  parameterSets = [] as ConfigurationModuleResourceWriteV2Api['parameterSets'],
): ConfigurationModuleResourceWriteV2Api {
  return {
    name,
    parameterSets,
    softwareVersion: { id: applicationVersion, type: softwareType ?? 'APPLICATION_VERSION' },
    ...(description?.trim() ? { description } : {}),
  };
}
